export default __webpack_public_path__ + "static/media/stm kebidanan.f054f1b9.png";